export function formatDate(date: Date | string): string {
	const dateObj = new Date(date);

	return dateObj.toLocaleDateString('pl-PL', { timeZone: 'Europe/Warsaw' });
}
